import type { GetApplicationResponse } from '@gdladder/shared/features';
import APIClient from '../../../../api/APIClient';
import { queryOptions } from '@tanstack/react-query';

export async function getApplication(appID: string) {
    return (await APIClient.get<GetApplicationResponse>(`/oauth/2/applications/${appID}`)).data;
}

export function getApplicationOptions(appId: string) {
    return queryOptions({
        queryKey: ['application', appId],
        queryFn: () => getApplication(appId),
    });
}
